import { Label } from '@/components/ui/shadcn/label';
import { Switch } from '@/components/ui/shadcn/switch';
import { Setting } from '@/types';

interface BooleanEditorProps {
    setting: Setting;
    onUpdate: (key: string, value: string | number | boolean | object | null) => void;
}

export default function BooleanEditor({ setting, onUpdate }: BooleanEditorProps) {
    const currentValue = setting.value as boolean;
    const switchId = `setting-${setting.key}`;

    const handleToggle = (checked: boolean) => {
        onUpdate(setting.key, checked);
    };

    return (
        <div className="space-y-3">
            <div className="flex items-center justify-between">
                <div className="space-y-1">
                    <Label htmlFor={switchId} className="text-sm font-medium">
                        Current Value
                    </Label>
                    <div className={`text-sm font-medium ${currentValue ? 'text-success-subtle-foreground' : 'text-destructive'}`}>
                        {currentValue ? 'Enabled' : 'Disabled'}
                    </div>
                </div>
                <Switch id={switchId} checked={currentValue} onCheckedChange={handleToggle} />
            </div>
            <p className="text-muted-foreground text-xs">Toggle this setting to enable or disable the feature.</p>
        </div>
    );
}
